import { Fragment } from 'react';
import fweImage from '../../../../../../assets/image/FWE.png';
import { FeatureFigure } from './FeatureFigure';

const features: { title: string; description: string }[] = [
  {
    title: 'Fast and simple setup',
    description:
      'Begin using the software effortlessly with a user-friendly web based setup. The interface provides access to pre-defined high-quality MIKE 21 Spectral Wave templates. Intended for all users, including novices and seasoned professionals.',
  },
  {
    title: 'Assisted meshing',
    description:
      'Generate a semi-automatic mesh instantly or upload custom meshes, including those created with MIKE Mesh Builder.',
  },
  {
    title: 'Flexible input data options',
    description:
      'Automatically access over 40 years of continuous boundary conditions from DHI sources, or upload your own data. MIKE Metocean Simulator provides the flexibility you need.',
  },
  {
    title: 'Cloud-powered simulation and storage',
    description:
      'MIKE Metocean Simulator runs simulations on 44 core virtual computers in the cloud. The cloud-based platform supports collaborative efforts while streamlining the management of project data.',
  },
  {
    title: 'Metocean On-Demand (MOOD)',
    description:
      'Seamlessly push data to the MOOD portal for map-based visualisation and data sharing while gaining access to powerful analytics.',
  },
  {
    title: 'Data validation in MOOD',
    description:
      'Enhance data quality control by generating validation plots for selected data points',
  },
];

export function MikeMetoceanSimulatorSection() {
  return (
    <>
      <h2>MIKE Metocean Simulator</h2>
      <p>
        Do you need to generate even higher resolution global data? Meet MIKE Metocean Simulator
        (MS), a fast, easy and flexible cloud-based wave modelling tool that seamlessly integrates
        with MetOcean On Demand.
      </p>
      <p>
        At the heart of MIKE Metocean Simulator (MS) lies a powerful set of features designed to
        make your wave modelling experience fast, easy, and flexible. MIKE Metocean Simulator
        seamlessly integrates with the MetOcean On-Demand (MOOD) portal to streamline your workflow.
      </p>
      {features.map((feature) => (
        <Fragment key={feature.title}>
          <br />
          <strong>{feature.title}</strong>
          <p>{feature.description}</p>
        </Fragment>
      ))}
      <br />
      <p>
        Visit the product page
        <a
          href="https://www.mikepoweredbydhi.com/products/mike-cloud/mike-metocean-simulator"
          target="_blank"
          rel="noreferrer noopener"
        >
          {' '}
          link{' '}
        </a>
        to learn more about how you can benefit from this simple, yet powerful wave modelling
        solution.
      </p>
      <h3>Local Model Area</h3>
      <p>
        The Local Model Area highlights the coverage scope of the Fast Wave Emulator, delineated by
        a gradient of yellow to greenThis represents the boundaries within which the FWE
        calculations are performed.
      </p>
      <h3>Local Model Point</h3>
      <p>
        The Local Model Point represents the specific coordinate where the Fast Wave Emulator
        operates and performs its calculations. This point is seamlessly integrated with the FWE
        system on the Mike Cloud platform.
      </p>
      <br />
      <FeatureFigure
        src={fweImage}
        caption="The Local Model Area, delineated by a yellow polygon, indicates the MIKE MS model boundaries. Within this area, the Local Model Points are represented by solid yellow dots, signifying specific coordinates where data from MIKE MS is available."
      />
    </>
  );
}
